import React, { useEffect, useState } from 'react'
import styles from "./Camp.module.css"
import { useAuth } from '../../components/context/Auth'
import TopTabBar from '../../components/updatedComponents/Tanolet/TopTabBar'
import { useParams } from 'react-router-dom'
import { useToast } from '../../components/updatedComponents/Toaster/Toaster'
import TimeOutFetch from '../../APIsControll/TimeOutFechControll'
import { changeDateFormat, changeTimeFormat, truncateText } from '../../Utils/TextUtils'
import { Spinner } from '../../components/icons/Icon'
import Skeleton from '../../components/updatedComponents/Skeleton/Skeleton'
import NoDataFound from '../../components/updatedComponents/NoDataFound/NoDataFound'
import { TemplateNotFound } from '../../components/icons/Icon2'
import GoToPage from '../../components/updatedComponents/Pagnation/GoToPage'
import PaginationComponent from '../../components/updatedComponents/Pagnation/Pagenation'
const CampaignReport = () => {
    const { mode, managerId } = useAuth();
    const { tempname, campaignName } = useParams();
    const { show } = useToast();
    const [data, setData] = useState();
    const [loading, setloading] = useState({
        loading1: false,
    })

    const getREport = async () => {
        const paload = {
            managerId,
            templateName: tempname,
            campaignName: campaignName
        }
        try {
            setloading((pre) => ({
                ...pre, loading1: true
            }))
            const res = await TimeOutFetch(`wallikonCampaign/campaignReportStatus`, paload);
            setloading((pre) => ({
                ...pre, loading1: false
            }))
            setData(res?.data);

        } catch (error) {
            show("Something went wrong.", " error");
            return
        }
    }

    useEffect(() => {
        getREport();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const uniqueScheduledDates = React.useMemo(() => {
        if (!data?.scheduledDates) return [];
        return [...new Set(data.scheduledDates.map(scheduled => scheduled.date))].sort();
    }, [data?.scheduledDates]);

    return (
        <div className={styles.mainCintner}>
            <div className={styles.Continer} style={{ backgroundColor: mode ? "#2C2E33" : "#F8F9FC" }} >
                <div className={styles.goBackCon}  >
                    <div className={styles.gobacFristChlid}>
                        <TopTabBar text={`Campaigns/Report`} />
                    </div>
                </div>
                <div className={styles.report_mainCon} style={{ backgroundColor: mode ? "#2C2E33" : "#F8F9FC", color: mode ? "#fff" : "#000" }} >
                    <div className={styles.templetReport} >
                        <span style={{ fontSize: "16px", color: "#4164E3", fontWeight: "500" }} > Status :  </span>
                        {loading.loading1 ? "Loading.." : <span style={{ fontSize: "16px", fontWeight: "400" }} > {data?.status.toUpperCase()}  </span>}

                    </div>
                    <div className={styles.templetReport} >
                        <span style={{ fontSize: "16px", color: "#4164E3", fontWeight: "500" }} > Template Name :  </span>
                        {loading.loading1 ? "Loading.." : <span style={{ fontSize: "16px", fontWeight: "400" }} > {tempname.toUpperCase()}  </span>}
                    </div>
                    <div className={styles.templetReport1} >
                        <div style={{ marginTop: "14px", color: mode ? "#9C9797" : "#646B88", }}>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Campaign Timing</span>
                        </div>
                        {loading.loading1 ? (
                            <div style={{ width: "70%", display: "flex", gap: "6px" }}>
                                {Array.from({ length: 3 }).map((_, i) => (
                                    <Skeleton lines={1} thickness={4} key={`${i}g`} />
                                ))}
                            </div>
                        ) : (
                            <div style={{ display: "flex", gap: "10px" }}>
                                {
                                    uniqueScheduledDates.map((date, index) => (
                                        <div
                                            className={styles.suduleTime}
                                            style={{ backgroundColor: mode ? "#000" : "#fff" }}
                                            key={index}
                                        >
                                            <div className={styles.suduleTime1}>
                                                <div>
                                                    {changeDateFormat(date, "-")} {changeTimeFormat(date)}
                                                </div>
                                            </div>
                                            <div className={styles.suduleTime2}></div>
                                        </div>
                                    ))
                                }
                            </div>
                        )}

                        <div className={styles.suduleTimeCart} style={{ backgroundColor: mode ? "#232529" : "#fff", color: mode ? "#fff" : "#000" }} >
                            <div className={styles.cartwidth} style={{ backgroundColor: mode ? "#1B1D21" : "#fff", border: mode ? "none" : "1px solid #E4E7EB" }} >
                                {loading.loading1 ? <Spinner size="30" /> :
                                    <div  >
                                        <div style={{ fontSize: "14px", fontWeight: "400" }} >Sent</div>
                                        <div style={{ fontSize: "18px", fontWeight: "500" }} >{data?.sentCount}</div>
                                    </div>
                                }
                            </div>
                            <div className={styles.cartwidth} style={{ backgroundColor: mode ? "#1B1D21" : "#fff", border: mode ? "none" : "1px solid #E4E7EB" }} >
                                {loading.loading1 ? <Spinner size="30" /> :
                                    <div  >
                                        <div style={{ fontSize: "14px", fontWeight: "400" }} >Total Cost</div>
                                        <div style={{ fontSize: "18px", fontWeight: "500" }} > ₹ {truncateText(`${data?.totalCost}`, 5)}</div>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className={styles.container} style={{ marginTop: "10px" }}>
                            <ul className={styles.responsiveTable}>
                                <li
                                    className={styles.tableHeader}
                                    style={
                                        mode
                                            ? { backgroundColor: "#232529", color: "#fafafa" }
                                            : { backgroundColor: "#D9DCE5" }
                                    }
                                >
                                    <div className={styles.col}>Dealer Name</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>Address</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>State</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>District</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>City</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>Dealer Status</div>
                                    <div className={`${styles.col} ${styles.colCenter}`}>Campaign Status</div>
                                </li>
                                <div className={mode ? styles.Table_row : styles.Table_row_light}>
                                    {loading.productLoading ? (<NoDataFound icon={<TemplateNotFound />} />
                                    ) : (
                                        Array.from({ length: 40 }).map((_, i) => (
                                            <li
                                                className={styles.tablerow}
                                                style={mode ? { backgroundColor: "#1B1D21", color: "#fafafa" } :
                                                    { backgroundColor: "#ffff" }}
                                                key={i}>
                                                <div className={styles.col} data-label="Status"> Mohit </div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name" > 106/109 Ghariyari Mandi Cant Road </div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name" >Uttar Pradesh</div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name" >Lucknow</div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name" >Lucknow</div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name"
                                                    style={{ color: (i / 2) % 2 === 0 ? "#F93E3E" : "#34A853" }} >
                                                    {(i / 2) % 2 === 0 ? "Deleted" : "Active"}</div>
                                                <div className={`${styles.col} ${styles.colCenter}`} data-label="Product Name"
                                                    style={{ color: (i / 2) % 2 === 0 ? "#F93E3E" : "#34A853" }} >{(i / 2) % 2 === 0 ? "Failed" : "Sent"}</div>
                                            </li>
                                        ))
                                    )}
                                </div>
                            </ul>
                        </div>
                        <div className={styles.pageNation} style={{ backgroundColor: mode ? "#232529" : "#fff" }} >
                            <div> <GoToPage /> </div>
                            <div><PaginationComponent /></div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    )
}

export default CampaignReport